<template>
  <label
    :for="inputId"
    class="ds-form-label"
    :data-test-id="dataTestId"
  >
    <slot />
    <span
      v-if="isRequired"
      class="ds-form-label__asterisk"
    >*</span>
    <span
      v-else-if="isOptional"
      class="ds-form-label__optional"
    >(Optional)</span>
  </label>
</template>

<script>
import htmlProps from '@/components/Ui/htmlProps';

export default {
  name: 'FormLabel',
  mixins: [htmlProps],
  props: {
    isOptional: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: null,
    },
  },
};
</script>
